import { ConfigProviderV5, ConfigProviderV5Props } from '@xhgj/xh-components'
type CustomConfigProviderV5Props = ConfigProviderV5Props
export default function CustomConfigProviderV5(
  props: CustomConfigProviderV5Props,
) {
  const { children } = props
  return (
    <ConfigProviderV5
      setTheme={(theme) => {
        if (!theme.components) {
          theme.components = {}
        }
        if (!theme.components.Table) {
          theme.components.Table = {}
        }
        if (!theme.components.Checkbox) {
          theme.components.Checkbox = {}
        }
        theme.components.Table = {
          ...theme?.components.Table,
          rowSelectedBg: '#e7e8ff',
          rowSelectedHoverBg: '	#e7e8ff',
        }
        theme.components.Checkbox = {
          ...theme?.components.Checkbox,
          colorPrimary: '#193274',
          colorPrimaryHover: '#193274',
          //  rowSelectedHoverBg: '	#e7e8ff',
        }
        return theme
      }}
    >
      {children}
    </ConfigProviderV5>
  )
}
import { ConfigProviderV5, ConfigProviderV5Props } from '@xhgj/xh-components'
type CustomConfigProviderV5Props = ConfigProviderV5Props
export default function CustomConfigProviderV5(
  props: CustomConfigProviderV5Props,
) {
  const { children } = props
  return (
    <ConfigProviderV5
      setTheme={(theme) => {
        if (!theme.components) {
          theme.components = {}
        }
        if (!theme.components.Table) {
          theme.components.Table = {}
        }
        if (!theme.components.Checkbox) {
          theme.components.Checkbox = {}
        }
        theme.components.Table = {
          ...theme?.components.Table,
          rowSelectedBg: '#e7e8ff',
          rowSelectedHoverBg: '	#e7e8ff',
        }
        theme.components.Checkbox = {
          ...theme?.components.Checkbox,
          colorPrimary: '#193274',
          colorPrimaryHover: '#193274',
          //  rowSelectedHoverBg: '	#e7e8ff',
        }
        return theme
      }}
    >
      {children}
    </ConfigProviderV5>
  )
}
